/**
 * Sentry browser SDK setup: errors and tracing.
 *
 * Imported first thing in `main.tsx` so the SDK is live before any app module
 * runs. `VITE_SENTRY_DSN` lives in the repo-root `.env` (vite.config.ts points
 * `envDir` there). When it is unset the SDK initialises as a no-op, so local
 * dev and any build without a DSN behave exactly as they did before.
 */

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // MODE is "development" under `vite dev` and "production" for a built bundle.
  // VITE_SENTRY_ENVIRONMENT overrides it so staging and prod can be told apart.
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  // Attach trace headers only to our own backend. Both the Vite dev proxy and
  // the production nginx expose it under a same-origin /api prefix, so this
  // relative pattern covers every environment without listing hostnames.
  tracePropagationTargets: [/^\/api\//],
});
